import React from "react";
import Analytics from "../components/Analytics";

const Dashboard = () => {
  return (
    <div
      className="p-6"
      style={{ backgroundColor: "#C6D2ED", minHeight: "100vh" }}
    >
      <Analytics />
    </div>
  );
};

export default Dashboard;
